import { HttpClient, HttpParams } from "@angular/common/http";
import { Environment, PaginatedList, utils } from "@fabrik/common";
import { UserCreditAccount, CreditTransaction, AddCreditTransaction } from "../models/Promoter";
import { Observable } from "rxjs";
import { TimeUtils } from "../utils/time-utils";
import { formatDate } from "@angular/common";


export class PromoterDataService {
    constructor(private environment: Environment, private http: HttpClient) { }

    /**
     * List promoters
     * @param tenantId id of the current tenant
     * @param args query params for pagination, sorting, etc.
     */
    list(tenantId: string, args: { page?: number; limit?: number; sortField?: string; sortDirection?: string; includeMarketPlaceProfiles?: boolean; query?: string; profileState?: string; } = {}): Observable<PaginatedList<UserCreditAccount>> {
        let params = new HttpParams()
        Object.keys(args).forEach(key => {
            switch (key) {
                case 'page':
                    if (utils.notNullOrUndefined(args.page)) {
                        params = params.set('page', (args.page - 1).toString())
                    }
                    break
                default:
                    if (utils.notNullOrUndefined(args[key])) {
                        params = params.set(key, args[key])
                    }
            }
        })
        return this.http.get<PaginatedList<UserCreditAccount>>(`${this.environment.appApiHost}/api/${tenantId}/admin/userCreditAccounts`, { params });
    }
    getTransactions(tenantId: string, startDate?: Date, endDate?: Date, args: { userId?: string, page?: number; limit?: number; sortField?: string; sortDirection?: string; } = {}): Observable<PaginatedList<CreditTransaction>> {
        let params = new HttpParams()
        Object.keys(args).forEach(key => {
            switch (key) {
                case 'page':
                    if (utils.notNullOrUndefined(args.page)) {
                        params = params.set('page', (args.page - 1).toString())
                    }
                    break
                default:
                    if (utils.notNullOrUndefined(args[key])) {
                        params = params.set(key, args[key])
                    }
            }
        });
        if (startDate && endDate) {            
            let fromDate = new Date(formatDate(startDate, 'E, d MMM yyyy HH:mm:ss Z', 'en'));
            let toDate = new Date(formatDate(endDate, 'E, d MMM yyyy HH:mm:ss Z', 'en'));
            params = params.set('from', TimeUtils.recreateDateAsUTC(fromDate).toISOString())
            params = params.set('to', TimeUtils.recreateDateAsUTC(toDate).toISOString())
        }
        return this.http.get<PaginatedList<CreditTransaction>>(`${this.environment.appApiHost}/api/${tenantId}/admin/userCreditAccounts/transactions`, { params });
    }
    addTransaction(tenantId: string, transaction: AddCreditTransaction){
        return this.http.post<CreditTransaction>(`${this.environment.appApiHost}/api/${tenantId}/admin/userCreditAccounts/adjustment`, transaction);
    }
    setState(tenantId: string, userId:string, userState :string ): Observable<UserCreditAccount> {
        return this.http.post<UserCreditAccount>(`${this.environment.appApiHost}/api/${tenantId}/admin/userCreditAccounts/state?userId=${userId}&userState=${userState}`,{});
    }

}

